import { computed, defineComponent } from 'vue';
export default defineComponent({
    props: {
        description: String,
        modelValue: String,
        disabled: Boolean,
        preview: Boolean
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const value = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });
        return {
            value
        };
    }
});
